import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import HomePage from "@/pages/HomePage";
import BlogPage from "@/pages/BlogPage";
import ProgramPage from "@/pages/ProgramPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import LoginPage from "@/pages/LoginPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import PortalDashboard from "@/pages/PortalDashboard";
import TourDetail from "@/pages/TourDetail";
import StudentForm from "@/pages/StudentForm";
import AdminDashboard from "@/pages/AdminDashboard";
import TeacherView from "@/pages/TeacherView";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App font-body">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Marketing */}
            <Route path="/" element={<HomePage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/programs/:slug" element={<ProgramPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            {/* Auth */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            {/* School Portal */}
            <Route path="/portal" element={<ProtectedRoute roles={["school_admin","super_admin"]}><PortalDashboard /></ProtectedRoute>} />
            <Route path="/portal/tours/:tourId" element={<ProtectedRoute roles={["school_admin","super_admin"]}><TourDetail /></ProtectedRoute>} />
            <Route path="/portal/tours/:tourId/students/new" element={<ProtectedRoute roles={["school_admin","super_admin"]}><StudentForm /></ProtectedRoute>} />
            <Route path="/portal/tours/:tourId/students/:studentId" element={<ProtectedRoute roles={["school_admin","super_admin"]}><StudentForm /></ProtectedRoute>} />
            <Route path="/portal/tours/:tourId/teacher" element={<ProtectedRoute roles={["school_admin","super_admin"]}><TeacherView /></ProtectedRoute>} />
            {/* Super Admin */}
            <Route path="/admin" element={<ProtectedRoute roles={["super_admin"]}><AdminDashboard /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
